import { isFinite } from 'lodash-es';
import { gql } from '@apollo/client';
import { GetStudyActivityTitle_StudyActivityInstanceFragment } from '@ui/utils/getStudyActivityTitle.generated';

function getStudyActivityTitle(activity: GetStudyActivityTitle_StudyActivityInstanceFragment) {
  const target = Number(activity.title);

  if (isFinite(target)) {
    return `Q${activity?.title}`;
  }

  return activity?.title;
}

export default getStudyActivityTitle;

gql`
  fragment getStudyActivityTitle_StudyActivityInstance on StudyActivityInstance {
    id
    title
  }
`;
